var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolderFileFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18,
    viewBox: "0 0 18.5 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Folder_file_fill",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M6,7c0-1.886,0-2.828.586-3.414S8.114,3,10,3h4c1.886,0,2.828,0,3.414.586S18,5.114,18,7V9c0,1.886,0,2.828-.586,3.414S15.886,13,14,13H10c-1.886,0-2.828,0-3.414-.586S6,10.886,6,9Z",
    fill: "#446fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M5,8h5.172a2,2,0,0,1,1.414.586l1.828,1.828A2,2,0,0,0,14.828,11H21.5",
    fill: "none",
    stroke: "#e3ecfc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M3,12H17.8a4.968,4.968,0,0,1,2.108.218,2,2,0,0,1,.874.874A4.968,4.968,0,0,1,21,15.2v2.6a4.968,4.968,0,0,1-.218,2.108,2,2,0,0,1-.874.874A4.968,4.968,0,0,1,17.8,21H6.2a4.968,4.968,0,0,1-2.108-.218,2,2,0,0,1-.874-.874A4.969,4.969,0,0,1,3,17.8Z",
    fill: "#446fa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M3,12a4.988,4.988,0,0,1,.152-1.765A2,2,0,0,1,4.235,9.152,4.988,4.988,0,0,1,6,9H8.343a4.255,4.255,0,0,1,1.594.152,4.255,4.255,0,0,1,1.235,1.019L13,12Z",
    fill: "#446fa2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFileFill);
export default __webpack_public_path__ + "static/media/Folder_file_fill.58d97eaffcbfa3a8d8bf39a36ddbd55a.svg";
export { ForwardRef as ReactComponent };